import React from 'react';

// picturs
import mathsriyadiyat0 from './../../documents/picturs/mathsriyadiyat0.png';
import mathspic4 from './../../documents/picturs/mathspic4.jpeg';
import mathspic3 from './../../documents/picturs/mathspic3.jpeg';
import mathspic1 from './../../documents/picturs/mathspic1.jpeg';
import mathspic2 from './../../documents/picturs/mathspic2.png';
import mathspic5 from './../../documents/picturs/mathspic5.jpeg';
import mathspic6 from './../../documents/picturs/mathspic6.jpeg';
import mathspic7 from './../../documents/picturs/mathspic7.jpeg';



import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Image from 'react-bootstrap/Image'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import CardColumns from 'react-bootstrap/CardColumns';
import ContentAds from './../ads/ContentAds.js'


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

// mathsriyadiyat.com.	14400	IN	TXT	v=spf1 a mx include:websitewelcome.com ~all


class Home extends React.Component{
  render(){
    return(
      <div>

      <CardColumns>
        <Card border="info">

          <Link to="/maths/3-eme/examen"><Card.Img variant="top" src={mathspic1} /></Link>
          <Card.Body>
            <Card.Title><Link to="/maths/3-eme/examen">3ème anné secondaire</Link></Card.Title>
            <Card.Text>
              Examens (PDF) des maths
            </Card.Text>
          </Card.Body>

        </Card>



        <Card border="info">
          <Link to="/maths/3/exercices"><Card.Img variant="top" src={mathspic5} /></Link>
          <Card.Body>
            <Card.Title><Link to="/maths/3/exercices">3ème anné secondaire</Link></Card.Title>
            <Card.Text>
              Exercices (PDF) + correction  dans les chapiters du premier semestre
            </Card.Text>
          </Card.Body>
        </Card>

        <Card border="info">
          <Link to="/maths/bac-2/examen"><Card.Img variant="top" src={mathspic2} /></Link>
          <Card.Body>
            <Card.Title><Link to="/maths/bac-2/examen">2ème année Bac - Examen national</Link></Card.Title>
            <Card.Text>
              الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم تجريبية
            </Card.Text>
          </Card.Body>
        </Card>


        <Card border="info">
          <Link to="/olympiad"><Card.Img variant="top" src={mathspic3} /></Link>
          <Card.Body>
            <Card.Title><Link to="/olympiad">Olympiques mathématiques</Link></Card.Title>
            <Card.Text>
            Voici des exemples que nous vous proposons pour vous entraîner.
            </Card.Text>
          </Card.Body>
        </Card>




        <Card border="info">
          <Link to="/programmation"><Card.Img variant="top" src={mathspic6} /></Link>
          <Card.Body>
            <Card.Title><Link to="/programmation">Aprender la programmation</Link></Card.Title>
            <Card.Text>
            python ; c/c++/c# ; java, kotlin; scala; goLang; Swift...
            </Card.Text>
          </Card.Body>
        </Card>




        <Card border="info">
            <Link to="/maths/2/exercices"><Card.Img src={mathspic4} /></Link>
            <Card.Body>
                <Card.Title><Link to="/maths/2/exercices">2ème année secondaire</Link></Card.Title>
                <Card.Text>
                  Exercices: le calcule litérale
                </Card.Text>
                <Card.Text>
                  pdf
                </Card.Text>
            </Card.Body>
        </Card>


        <Card border="info">
            <Link to="/maths/1/exercices"><Card.Img src={mathspic7} /></Link>
            <Card.Body>
                <Card.Title><Link to="/maths/1/exercices">تمارين مع التصحيح للأولى إعدادي</Link></Card.Title>

                <Card.Text>
                  تمارين درس المعادلات<br/>
                  تمارين درس القوى <br/>
                  تمارين درس النشر و التعميل
                </Card.Text>
            </Card.Body>
        </Card>

      </CardColumns>






      </div>
    );
  }
}

export default Home;
